const isLeapYear = (year) => {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};

export const getYearCalendar = (year) => {
  const months = [
    {
      key: 1,
      val: 31,
    },
    {
      key: 2,
      val: isLeapYear(year) ? 29 : 28,
    },
    {
      key: 3,
      val: 31,
    },
    {
      key: 4,
      val: 30,
    },
    {
      key: 5,
      val: 31,
    },
    {
      key: 6,
      val: 30,
    },
    {
      key: 7,
      val: 31,
    },
    {
      key: 8,
      val: 31,
    },
    {
      key: 9,
      val: 30,
    },
    {
      key: 10,
      val: 31,
    },
    {
      key: 11,
      val: 30,
    },
    {
      key: 12,
      val: 31,
    },
  ];
  return months.map((m) =>
    [...Array(m.val).keys()].map((y) => ({
      [`${y + 1}`]: new Date(`${m.key},${y + 1},${year}`).getDay(),
    }))
  );
};

export const getCopticCalendar = (year) => {
  const months = [
    {
      key: 1,
      val: 30,
    },
    {
      key: 2,
      val: 30,
    },
    {
      key: 3,
      val: 30,
    },
    {
      key: 4,
      val: 30,
    },
    {
      key: 5,
      val: 30,
    },
    {
      key: 6,
      val: 30,
    },
    {
      key: 7,
      val: 30,
    },
    {
      key: 8,
      val: 30,
    },
    {
      key: 9,
      val: 30,
    },
    {
      key: 10,
      val: 30,
    },
    {
      key: 11,
      val: 30,
    },
    {
      key: 12,
      val: 30,
    },
    {
      key: 13,
      val: isLeapYear(year + 1) ? 6 : 5,
    },
  ];

  let day = isLeapYear(year)
    ? new Date(`9, 12, ${year + 283}`).getDay()
    : new Date(`9, 11, ${year + 283}`).getDay();

  return months.map((m) =>
    [...Array(m.val).keys()].map((y) => {
      if (day > 6) day = 0;
      return {
        [`${y + 1}`]: day++,
      };
    })
  );
};

export const copticMonths = [
  "Thoout",
  "Paope",
  "Hathor",
  "Koiahk",
  "Tobe",
  "Meshir",
  "Paremhotep",
  "Parmoute",
  "Pashons",
  "Paone",
  "Epep",
  "Mesore",
  "Nesi",
];

export const regularMonths = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
